export const WhatAreMixedUseProperties = () => {
  const characteristics = [
    {
      icon: 'ri-building-4-line',
      title: 'Multiple Uses',
      description: 'Combination of residential units with retail, office, or commercial space'
    },
    {
      icon: 'ri-store-2-line',
      title: 'Ground Floor Retail',
      description: 'Typically retail or commercial on ground floor with apartments above'
    },
    {
      icon: 'ri-community-line',
      title: 'Urban Locations',
      description: 'Prime locations in downtown areas, main streets, and transit corridors'
    },
    {
      icon: 'ri-funds-line',
      title: 'Diverse Income',
      description: 'Multiple revenue streams from different tenant types and uses'
    }
  ];

  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold mb-6 text-gray-900">
            What Are Mixed-Use Properties?
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed">
            Mixed-use properties combine residential and commercial spaces in a single building, creating vibrant, walkable communities while providing diverse income streams for investors. These properties represent the future of urban development.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8 mb-16">
          {characteristics.map((item, index) => (
            <div key={index} className="bg-gray-50 rounded-xl p-6 hover:shadow-lg transition-all duration-300">
              <div className="w-14 h-14 flex items-center justify-center bg-teal-500 text-white rounded-lg mb-4">
                <i className={`${item.icon} text-2xl`}></i>
              </div>
              <h3 className="text-xl font-bold mb-3 text-gray-900">{item.title}</h3>
              <p className="text-gray-600 leading-relaxed">{item.description}</p>
            </div>
          ))}
        </div>

        <div className="bg-gradient-to-br from-teal-50 to-cyan-50 rounded-2xl p-8 md:p-12">
          <h3 className="text-2xl font-bold mb-6 text-gray-900">Why Mixed-Use Properties Are Unique</h3>
          <div className="grid md:grid-cols-2 gap-8">
            <div>
              <h4 className="text-lg font-semibold mb-3 text-gray-900">Investment Advantages</h4>
              <ul className="space-y-3 text-gray-700">
                <li className="flex items-start">
                  <i className="ri-check-line text-teal-500 text-xl mr-3 mt-1"></i>
                  <span>Diversified income from multiple tenant types</span>
                </li>
                <li className="flex items-start">
                  <i className="ri-check-line text-teal-500 text-xl mr-3 mt-1"></i>
                  <span>Higher property values in prime urban locations</span>
                </li>
                <li className="flex items-start">
                  <i className="ri-check-line text-teal-500 text-xl mr-3 mt-1"></i>
                  <span>Strong demand from lifestyle-focused tenants</span>
                </li>
                <li className="flex items-start">
                  <i className="ri-check-line text-teal-500 text-xl mr-3 mt-1"></i>
                  <span>Potential for higher overall returns</span>
                </li>
              </ul>
            </div>
            <div>
              <h4 className="text-lg font-semibold mb-3 text-gray-900">Management Considerations</h4>
              <ul className="space-y-3 text-gray-700">
                <li className="flex items-start">
                  <i className="ri-arrow-right-line text-teal-500 text-xl mr-3 mt-1"></i>
                  <span>More complex management with different tenant types</span>
                </li>
                <li className="flex items-start">
                  <i className="ri-arrow-right-line text-teal-500 text-xl mr-3 mt-1"></i>
                  <span>Different lease structures and terms by use type</span>
                </li>
                <li className="flex items-start">
                  <i className="ri-arrow-right-line text-teal-500 text-xl mr-3 mt-1"></i>
                  <span>Varied operating hours and tenant needs</span>
                </li>
                <li className="flex items-start">
                  <i className="ri-arrow-right-line text-teal-500 text-xl mr-3 mt-1"></i>
                  <span>Zoning and regulatory compliance requirements</span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};